// Utility functions pulled from p5.func since the library doesn't work in p5 instance mode:
// https://idmnyu.github.io/p5.js-func/

export const backInOut = function (_x) {
  if (_x < 0.5) {
    var f = 2 * _x;
    return 0.5 * (f * f * f - f * Math.sin(f * Math.PI));
  } else {
    var f = 1 - (2 * _x - 1);
    return 0.5 * (1 - (f * f * f - f * Math.sin(f * Math.PI))) + 0.5;
  }
};

export const backIn = function (_x) {
  return _x * _x * _x - _x * Math.sin(_x * Math.PI);
};

export const backOut = function (_x) {
  var f = 1 - _x;
  return 1 - (f * f * f - f * Math.sin(f * Math.PI));
};

export const circularIn = function (_x) {
  return 1 - Math.sqrt(1 - _x * _x);
};

export const circularOut = function (_x) {
  return Math.sqrt((2 - _x) * _x);
};
